import { Injectable } from '@angular/core';

import { TellentHttpApiService } from '@tellent/http';
import {
  InviteMemberPayload,
  TeamMembersPaginationParams,
  TellentMember,
  TellentMemberResponse,
  TellentMembersResponse,
} from '@tellent/types';
import { map, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class TellentMembersHttpClient {
  constructor(protected httpApi: TellentHttpApiService) {}

  public inviteMember(payload: InviteMemberPayload): Observable<TellentMember[]> {
    return this.httpApi
      .post('/members/add', null, payload)
      .pipe(map((response: TellentMembersResponse) => response.data));
  }

  public fetchMemberByEmail(email: string): Observable<TellentMember[]> {
    return this.httpApi
      .get('/members', { email }, null)
      .pipe(map((response: TellentMembersResponse) => response.data));
  }

  public fetchMembers(params: TeamMembersPaginationParams): Observable<TellentMembersResponse> {
    const { page, limit, q, statuses, sortBy, sortOrder } = params;
    return this.httpApi.get('/members', { page, limit, q, statuses, sortBy, sortOrder });
  }

  public deactivateMember(payload: { guid: string }): Observable<TellentMemberResponse> {
    return this.httpApi.patch(`/members/${payload.guid}/deactivate`);
  }

  public reactivateMember(payload: { guid: string }): Observable<TellentMemberResponse> {
    return this.httpApi.patch(`/members/${payload.guid}/reactivate`);
  }

  public resendInvitation(payload: { id: number }): Observable<TellentMemberResponse> {
    return this.httpApi.patch(`/invitations/${payload.id}/resend`);
  }

  public sendInvitation(payload: { guid: string }): Observable<TellentMemberResponse> {
    return this.httpApi.patch(`/invitations`, null, { memberGuid: payload.guid });
  }
}
